import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

interface EventTypeDurationProps {
  duration: string;
  onDurationChange: (value: string) => void;
}

export function EventTypeDuration({
  duration,
  onDurationChange,
}: EventTypeDurationProps) {
  return (
    <Select value={duration} onValueChange={onDurationChange}>
      <SelectTrigger id="duration">
        <SelectValue placeholder="Select duration" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="15">15 minutes</SelectItem>
        <SelectItem value="30">30 minutes</SelectItem>
        <SelectItem value="45">45 minutes</SelectItem>
        <SelectItem value="60">60 minutes</SelectItem>
        <SelectItem value="90">90 minutes</SelectItem>
        <SelectItem value="120">120 minutes</SelectItem>
      </SelectContent>
    </Select>
  );
}
